'use client'

import { useModal } from '@/src/shared/hooks/useModal'
import { PrimaryButton } from '@/src/shared/ui/button/PrimaryButton'

interface LoginButtonProps {
  label: string
  className?: string
}

/**
 * Feature: Login Button
 * Открывает модальное окно входа (с возможностью перехода на регистрацию)
 */
export function LoginButton({ label, className }: LoginButtonProps) {
  const { open: openLoginModal } = useModal('login')

  return (
    <PrimaryButton onClick={() => openLoginModal()} className={className}>
      {label}
    </PrimaryButton>
  )
}
